// extracted by mini-css-extract-plugin
module.exports = {"ImagesCarousel":"styles_ImagesCarousel__UkbEa","height":"styles_height__Vg_Mq"};